import React from 'react'
import Gallery from './imageGallery/Gallery'
import Icon from './misc/Icons'
import Button from './uiKit/Button' 
 
class ImageSearch extends React.Component{

	constructor(props){
		super()
		this.handleKeyPress=this.handleKeyPress.bind(this)
		this.sizeChanged=this.sizeChanged.bind(this)
		this.onSelectImage=this.onSelectImage.bind(this)

		this.state=({
      		images:props.images,
      		index:null,
      		image:null,
      		searchTerm:props.searchTerm
      	})
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({images:nextProps.images})
	}


	handleChange(e){
		this.setState({ searchTerm: e.target.value })
	}

	handleKeyPress(e){
		if (e.keyCode === 13) {
			this.props.imageSearch(this.state.searchTerm)
		}
	}

	sizeChanged(dimensions){
    	this.setState({dimensions})
	}

	onSelectImage (index, image) {
		var images = this.state.images.slice()
		this.setState({image:image,index:index})
		images.forEach((image,i) => {
			if(i===index){
				if(image.isSelected===true){
					image.isSelected=false
					this.setState({image:null,index:null})
				}else{
					image.isSelected=true
				}
			}else{
				image.isSelected = false
			}
		})
		this.setState({
			images: images
		})
	}


	render(){
		const {isSearching,isGif,noResults,searchTerm,images,errorMessage,disableGifs}=this.props		
		return(
			<div className='imageSearch u-unselectable'>				
			
				<div className='imageSearch-search'>
					
					<input autoFocus required type='text' value={this.state.searchTerm} placeholder={!isGif ? 'Search Internet for Images' : 'Search GIPHY for GIFs'} onChange={(e)=>{this.handleChange(e)} } onKeyDown={this.handleKeyPress} />						  					
					<div className='imageSearch-search-inputUI'>
						<div className='imageSearch-search-searchBtn' onClick={() =>{this.props.imageSearch(this.state.input)}}>
							<Icon name='magnifying-glass' />
						</div>
						{images.length===0 && isSearching ===false && noResults===false &&
							<div className='imageSearch-search-hint'>
								Press <div className='imageSearch-search-hint-keyboard'>Enter <Icon name='enterKey' /></div> to Search
							</div>
						}
						{images.length===0 && isSearching ===true &&
							<div className='imageSearch-search-hint'>
								Looking for {this.state.searchTerm}s ...
							</div>
						}
					</div>
					
				</div>


				<div className={'imageSearch-body ' + (images.length===0 ? 'is--empty' : '')}>						

					{!isGif && images.length===0 && 
						<div className='imageSearch-body-emptyBG'>						
							<Icon name='newImage' />
						</div>
					}


					{isGif && images.length===0 && 
						<div className='imageSearch-body-emptyBG imageSearch-body-emptyBG--GIF'>						
							<img alt='' src='https://assets.plickers.com/react-assets/images/Poweredby_640px-White_HorizText.png' />
						</div>
					}					


					{noResults===true &&
						<div className='imageSearch-body-noResults'>							
							No Results for '{searchTerm}'
						</div>	
					}

					{errorMessage&&
						<div className='imageSearch-body-noResults'>							
							{errorMessage}
						</div>	
					}
	

					{noResults===false && images.length>0 &&
						
						<div className={'imageSearch-imageGrid' + (this.state.image ? ' has--selectedImage' : '')}>							 
							 <Gallery 
							 	images={images}
							 	onClickThumbnail={this.props.onImageSelected}
							 	/>								
						</div>
														
					}


					{isSearching && images.length>0 &&
							<div>						 			
					 		<div className='imageSearch-imageGrid-loadMore'>
					 			<Button label="Loading More" size="medium" />			 					
			 				</div>
				 		</div>
					}



					{images.length>0 && isSearching ===false && images.length < parseInt(this.props.searchResultCount,10) &&
				 		<div>						 			
					 		<div className='imageSearch-imageGrid-loadMore'>
					 			<Button label="Show more results" size="medium" onClickFunction={() =>{this.props.loadMore()}} />			 					
			 				</div>
				 		</div>
					}

					{isGif && images.length>0 && isSearching ===false &&
						<div>						 			
							<div className='imageSearch-imageGrid-loadMore'>
								<Button label="Show more Gifs" size="medium" onClickFunction={() =>{this.props.loadMoreGifs()}} />			 					
							</div>
						</div>

					}


				</div>

	

					
				<div className={'imageSearch-footer' + (images.length>0 ? ' has--images' : ' has--noImages')}>					
					
					<div className='imageSearch-footer-upload'>
						<input 
							id='file'
							type='file'
							value={''} 
							name='uploadImage'
							accept={'.png,.jpg,.jpeg,.tif,.tiff'+`${disableGifs?'':',.gif'}`}
							className='imageSearch-footer-uploadBtn-hiddenInput' onChange={(e) =>{
						       this.props.handleFileUpload(e)}} />							     
						<label htmlFor='file' className='imageSearch-footer-uploadBtn'>Upload Image from Computer...</label>
					</div>
										
				</div>
			</div>
		)
	}
}
					



export default ImageSearch



// WEBPACK FOOTER //
// ./src/components/ImageSearch.js